import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  IAddEditMarketmakingTask,
  IMarketmakingTaskSearchParam,
  IMarketmakingTaskTableReport,
  MarketmakingTableTabs,
} from "../../../Interfaces/marketmaking";
import { getMarketmakingTasksTable } from "../../../Requests/marketmaking";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setMarketmakingAddTaskFormValues,
  setMarketmakingTabIndex,
  setMarketmakingTaskTableClickedRowValues,
  setMarketmakingTaskTableFetchDataFlag,
} from "../../../Features/Marketmaking/marketmakingSlice";
import { MarketmakingTaskTableAdditional } from "./Additional";
import { useEffect } from "react";

interface IProps {
  searchParam: IMarketmakingTaskSearchParam;
  refreshInstruments: () => void;
}

const TasksTable = ({ searchParam, refreshInstruments }: IProps) => {
  const dispatch = useAppDispatch();
  const flag = useAppSelector(
    (store) => store.marketmaking.tasksTableFetchDataFlag
  );

  useEffect(() => {
    if (flag) dispatch(setMarketmakingTaskTableFetchDataFlag(false));
  }, [flag]);

  const onTableRowClick = (row: IMarketmakingTaskTableReport) => {
    dispatch(setMarketmakingTaskTableClickedRowValues(row));
    dispatch(
      setMarketmakingAddTaskFormValues({
        // id: row.id,
        // accountId: row.userId,
        insId: row.optionId,
        // threshold: row.threshold,
        // volatility: row.volatility,
      } as IAddEditMarketmakingTask)
    );
    // dispatch(setMarketmakingTabIndex(MarketmakingTableTabs.Program));
  };

  return (
    <div className="overflow-auto order-table w-full">
      <TableTemplate<IMarketmakingTaskSearchParam, IMarketmakingTaskTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={getMarketmakingTasksTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={() => {
              if (!onAction) return;
              onAction();
              refreshInstruments();
            }}
            onTableRowClick={onTableRowClick}
            sortingType={sortingType}
            setSortingType={setSortingType}
            AdditionalBody={MarketmakingTaskTableAdditional}
            refreshFlag={flag}
            withSelect
            tableBoxClassName="max-h-[350px]"
          />
        )}
        searchParameters={searchParam}
      />
    </div>
  );
};

export default TasksTable;
